import { useQuery } from '@tanstack/react-query';

import { fetchTreatPoints, TreatPointsBody } from '../api';
import { TREAT_POINTS_QUERY_KEY } from './queryKey';

type UseTreatPointsQueryProps = TreatPointsBody & {
    enabled?: boolean;
};

export const useUserTreatPointsQuery = ({ sku, price, quantity, enabled }: UseTreatPointsQueryProps) => {
    return useQuery({
        enabled,
        select: data => data?.treatPoints.toString(),
        queryFn: () => fetchTreatPoints({ sku, quantity, price }),
        queryKey: [TREAT_POINTS_QUERY_KEY, sku, quantity, price].filter(Boolean),
    });
};
